import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Unlock, Plus } from "lucide-react";
import { api } from "../lib/api";
import { STATUS_OPTIONS, deptName, formatErr } from "../lib/constants";

export default function PuantajDeptCard({ dept, record, onChanged, date, hotel }) {
  const [statuses, setStatuses] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const m = {};
    record?.entries.forEach((e) => { m[e.personnel_id] = e.status; });
    setStatuses(m);
  }, [record]);

  const dirty = record?.entries.some((e) => statuses[e.personnel_id] !== e.status);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/puantaj/${record.id}`, { entries: Object.entries(statuses).map(([personnel_id, status]) => ({ personnel_id, status })) });
      toast.success(`${deptName(dept)} puantajı güncellendi`);
      onChanged();
    } catch (e) { toast.error(formatErr(e)); }
    setSaving(false);
  };

  const unlock = async () => {
    if (!window.confirm("Kayıt silinip şefin yeniden girişine açılacak. Emin misiniz?")) return;
    try { await api.delete(`/puantaj/${record.id}`); toast.success("Kilit açıldı, şef yeniden giriş yapabilir"); onChanged(); }
    catch (e) { toast.error(formatErr(e)); }
  };

  const create = async () => {
    try { await api.post("/puantaj/admin-create", { date, hotel_code: hotel, department_code: dept }); toast.success("Kayıt oluşturuldu, durumları düzenleyebilirsiniz"); onChanged(); }
    catch (e) { toast.error(formatErr(e)); }
  };

  return (
    <div data-testid={`gp-dept-${dept}`} className={`glass-card p-4 border ${record ? "border-emerald-500/30" : "border-rose-500/30"}`}>
      <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
        <div>
          <div className="font-display text-sm font-bold text-cyan-200 tracking-wider uppercase">{deptName(dept)}</div>
          <div className="text-[10px] font-mono text-slate-400">
            {record ? `${record.submitted_by_name} · ${new Date(record.submitted_at).toLocaleString("tr-TR")}${record.edited_by ? " · İK düzenledi" : ""}` : "Puantaj girilmedi"}
          </div>
        </div>
        {!record && (
          <button data-testid={`gp-create-${dept}`} onClick={create} className="btn-cyan px-3 py-1.5 rounded-lg font-mono text-[10px] uppercase tracking-widest flex items-center gap-1.5">
            <Plus className="w-3.5 h-3.5" /> Kayıt Oluştur
          </button>
        )}
        {record && (
          <div className="flex gap-2">
            <button data-testid={`gp-save-${dept}`} disabled={!dirty || saving} onClick={save} className="btn-cyan px-3 py-1.5 rounded-lg font-mono text-[10px] uppercase tracking-widest flex items-center gap-1.5 disabled:opacity-40">
              <Save className="w-3.5 h-3.5" /> Kaydet
            </button>
            <button data-testid={`gp-unlock-${dept}`} onClick={unlock} className="px-3 py-1.5 rounded-lg border border-amber-500/40 text-amber-300 hover:bg-amber-500/10 font-mono text-[10px] uppercase tracking-widest flex items-center gap-1.5">
              <Unlock className="w-3.5 h-3.5" /> Kilidi Aç
            </button>
          </div>
        )}
      </div>
      {record && (
        <div className="space-y-1.5">
          {record.entries.map((e) => (
            <div key={e.personnel_id} className="flex items-center justify-between flex-wrap gap-2 p-2 rounded bg-slate-900/40 border border-cyan-500/10">
              <div className="flex items-center gap-3">
                <span className="font-mono text-xs text-cyan-400 w-10">#{e.sira_no}</span>
                <div><div className="text-sm text-slate-200">{e.full_name}</div><div className="text-[10px] text-slate-500 font-mono">{e.role}</div></div>
              </div>
              <select data-testid={`gp-status-${e.personnel_id}`} value={statuses[e.personnel_id] || e.status}
                onChange={(ev) => setStatuses((s) => ({ ...s, [e.personnel_id]: ev.target.value }))}
                className={`px-2 py-1 rounded-full text-[10px] font-mono uppercase border bg-slate-950 ${STATUS_OPTIONS.find((o) => o.code === (statuses[e.personnel_id] || e.status))?.cls}`}>
                {STATUS_OPTIONS.map((o) => <option key={o.code} value={o.code}>{o.label}</option>)}
              </select>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
